import React, { useState } from "react";
import "./Login.css";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaUser, FaEnvelope, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config"; 

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState(""); 
  const [error, setError] = useState(""); 
  const [successMessage, setSuccessMessage] = useState(""); 
  const [passwordVisible, setPasswordVisible] = useState(false);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate input fields
    if (!email || !password) {
      setError("Please fill in both fields.");
      return;
    }

    const requestData = { email, password };

    try {
      console.log("Submitting form...");
      const response = await axios.post(`${config.backendUrl}/api/login`, requestData);

      if (response.status === 200) {
        localStorage.setItem("isAuthenticated", "true");  
        setSuccessMessage("Login successful!"); 
        setError(""); 
        console.log("Navigating to dashboard...");
        navigate("/dashboard");  
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError(err.response?.data?.message || "Something went wrong. Try again.");
    }
  };

  return (
    <Container
      fluid
      className="login-container d-flex justify-content-center align-items-center vh-100"
    >
      <Row className="shadow-lg rounded overflow-hidden" style={{ maxWidth: "740px", minHeight: "500px" }}>
        {/* Left Side (Login Form) */}
        <Col md={6} className="p-4 bg-white d-flex flex-column">
          <h2 className="text-center mb-4">Log In</h2>
          <div className="icon-wrapper text-center mb-3">
            <FaUser className="user-icon" />
            <p className="user-text">User</p>
          </div>
          <Form className="flex-grow-1 d-flex flex-column justify-content-between" onSubmit={handleSubmit}>
            <div>
              <Form.Group controlId="formBasicEmail" className="mb-3">
                <div className="input-group">
                  <span className="input-group-text">
                    <FaEnvelope />
                  </span>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </Form.Group>

              <Form.Group controlId="formBasicPassword" className="mb-3">
                <div className="input-group">
                  <span className="input-group-text" onClick={togglePasswordVisibility}>
                    {passwordVisible ? <FaEye /> : <FaEyeSlash />}
                  </span>
                  <Form.Control
                    type={passwordVisible ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </Form.Group>
            </div>

            {/* Error & Success Messages */}
            {error && <p className="text-danger text-center">{error}</p>}
            {successMessage && <p className="text-success text-center">{successMessage}</p>}

            <Form.Text className="text-center d-block mb-3">Forgot your password?</Form.Text>

            <Button variant="success" type="submit" className="w-100 mb-3">Log In</Button>
          </Form>
        </Col>

        {/* Right Side (Welcome Back) */}
        <Col
          md={6}
          className="p-4 text-white d-flex flex-column justify-content-center align-items-center signup-section"
          style={{
            background: "linear-gradient(63deg, rgba(2,0,36,1) 0%, rgba(219,169,92,1) 0%, rgba(230,204,72,1) 100%)",
            border: "none"
          }}
        >
          <div className="text-center">
            <h2 style={{ color: "#5a5c5a" }}>Welcome Back!</h2>
            <p style={{ color: "white" }}>
              To keep connected with us, please login with your personal info
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
